import type {
  BoxListItem,
  BoxProductItem,
  IWarehouseApi,
  UpdateProductInput,
} from "../../../api/WarehouseApi";
import { Action } from "../../../types/entities";
import { normalizeTypeTags } from "../../../utils/typeTags";
import { normalizeDeleteReason } from "../../shared/use-cases/delete-flow";

export async function removeProductFromBox(input: {
  api: IWarehouseApi;
  boxId: string;
  item: BoxProductItem;
}): Promise<void> {
  const payload: UpdateProductInput = {
    name: input.item.name,
    photo: input.item.photo || "",
    photos: input.item.photos,
    description: input.item.description || "",
    manufacturingDate: input.item.manufacturingDate,
    expiryDate: input.item.expiryDate,
    typeTags: normalizeTypeTags(input.item.typeTags),
    measure: input.item.measure,
    quantity: input.item.quantity,
    parentId: null,
  };

  await input.api.updateProduct(input.item.id, payload);
  await input.api.createJournalEntry({
    action: Action.take,
    productId: input.item.id,
    fromTo: input.boxId,
    value: 1,
  });
}

export async function detachChildBox(input: {
  api: IWarehouseApi;
  item: BoxListItem;
}): Promise<void> {
  await input.api.updateBox(input.item.id, {
    name: input.item.name,
    photo: input.item.photo || "",
    description: input.item.description || "",
    typeTags: normalizeTypeTags(input.item.typeTags),
    parentId: null,
  });
}

export async function deleteChildBox(input: {
  api: IWarehouseApi;
  childBoxId: string;
  deleteReason?: string | null;
}): Promise<void> {
  await input.api.deleteBox(
    input.childBoxId,
    normalizeDeleteReason(input.deleteReason),
  );
}
